export default "__VITE_ASSET__wKvZhp5o__"